module.exports = __webpack_public_path__ + "img/grpsh.db1b5055.png";